import { useData } from '../../useData';
import { ErrorMsg } from '../../components/Modal';

interface Entry {
  id: number; occurredAt: string; userName: string | null; entityType: string;
  entityId: number; action: string; details: string | null;
}

const ACTIONS: Record<string, string> = {
  Created: 'a creat', Updated: 'a modificat', Archived: 'a arhivat', MemberSet: 'a setat un membru',
  MemberRemoved: 'a eliminat un membru', OverridesChanged: 'a modificat fișa de rol',
};
const ENTITIES: Record<string, string> = { User: 'utilizatorul', Role: 'rolul', Workspace: 'workspace-ul' };

export function AuditPage() {
  const { data, error } = useData<Entry[]>('/admin/audit?top=300');
  return (
    <>
      <div className="page-head"><h1>Jurnal de activitate</h1></div>
      <ErrorMsg error={error} />
      <table>
        <thead><tr><th>Când</th><th>Cine</th><th>Ce</th><th>Detalii</th></tr></thead>
        <tbody>
          {data?.map((e) => (
            <tr key={e.id}>
              <td className="nowrap small">{new Date(e.occurredAt).toLocaleString('ro-RO')}</td>
              <td>{e.userName ?? '—'}</td>
              <td>{ACTIONS[e.action] ?? e.action} {ENTITIES[e.entityType] ?? e.entityType} #{e.entityId}</td>
              <td className="muted small mono">{e.details?.slice(0, 160)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
